import { Skeleton, SkeletonLines } from "components/new-stuff/ui/Skeleton"

export const StatsCard = ({
  image,
  title,
  text,
  loading = false,
  handleClick,
  id,
  maskText,
}: {
  image: string
  title: string
  text: string | number | undefined
  loading?: boolean
  handleClick?: Function
  id?: string
  maskText?: boolean
}) => {
  return (
    <div
      id={id}
      className="font-avenir flex items-center justify-start bg-white border border-[#e5e7eb] rounded-lg py-4"
      // A card mid-load is not a card you can act on, so the click is dropped
      // rather than firing against a value that has not arrived.
      onClick={() => {
        if (loading) return
        handleClick?.()
      }}
      aria-busy={loading}
    >
      <div className="flex-shrink-0 mx-3">
        {loading ? (
          <Skeleton
            variant="circle"
            width="32px"
            height="32px"
          />
        ) : (
          <img
            src={image}
            alt="Amount"
          />
        )}
      </div>
      {loading ? (
        // Two bars at the sizes the label and the figure occupy, so the card
        // keeps its height and nothing shifts when the number lands.
        <div className="flex flex-col gap-2">
          <Skeleton width="90px" />
          <Skeleton
            width="60px"
            height="18px"
          />
        </div>
      ) : (
        <div>
          <p className="font-circular text-sm text-neutral500">{title}</p>
          <p
            className={`font-semibold text-neutral500 text-lg font-circular${
              maskText ? " mp-mask" : ""
            }`}
          >
            {text}
          </p>
        </div>
      )}
    </div>
  )
}

export const InfoCard = ({
  title,
  description,
  actions,
  children,
  loading,
}: {
  title: string
  description?: string
  actions?: React.ReactNode
  children: React.ReactNode
  loading: boolean
}) => {
  return (
    <div className="bg-white border border-white shadow-md rounded-xl">
      <div className="py-5 px-6 flex items-center justify-between gap-4">
        <div>
          <h2 className="text-neutral500 font-circular font-bold">{title}</h2>
          <p className="text-dark40 text-sm">{description}</p>
        </div>
        <div>{actions}</div>
      </div>
      <hr className="border-b border-neutral40" />
      <div>
        {loading ? (
          <div
            className="px-6 py-5"
            aria-busy="true"
          >
            <SkeletonLines lines={3} />
          </div>
        ) : (
          <>{children}</>
        )}
      </div>
    </div>
  )
}
